import axios from 'axios';

import { HOST_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/login/recuperarSesion',
    login: '/login',
    register: '/users/users',
    forgotPassword: '/login/recuperarContrasena',
    resetPassword: '/login/cambiar-contrasena',
    verificarToken: (token) => `/login/verificar-token-reset/${token}`,
    catalogs: '/users/users/catalogs',
    logout: (usuario) => `/login/${usuario}`,
  },
  public: {
    termsAndConditions: '/public/documentos/terminosYcondiciones',
    privacyPolicy: '/public/documentos/politicaPrivacidad',
    eDocuments: '/public/documentos/eDocument',
    tutoriales: '/public/documentos/tutoriales'
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/administracion/productos',
    create: '/administracion/productos',
    update: '/administracion/productos',
    delete: '/administracion/productos',
    ajustarStock: '/administracion/productos/ajustar-stock',
    cargaMasiva: '/administracion/productos/carga-masiva',
    updatePrecio: '/administracion/productos/update/precios',
    detalle: '/administracion/productos/detalle',
    quickNotes: {
      list: '/administracion/notas-rapidas',
      create: '/administracion/notas-rapidas',
      update: '/administracion/notas-rapidas',
      delete: '/administracion/notas-rapidas',
    }
  },
  settingFel: {
    list: '/administracion/configuracionFel',
    create: '/administracion/configuracionFel',
    update: '/administracion/configuracionFel',
    delete: '/administracion/configuracionFel',
  },
  user: {
    list: '/administracion/usuarios',
    create: '/administracion/usuarios',
    update: '/administracion/usuarios',
    delete: '/administracion/usuarios',
    changePassword: '/administracion/usuarios/cambiarContrasena',
    updateCompany: '/administracion/usuarios/updateCompany'
  },
  rol: {
    list: '/administracion/roles',
    create: '/administracion/roles',
    update: '/administracion/roles',
    delete: '/administracion/roles',
  },
  companie: {
    list: '/administracion/empresas',
    create: '/administracion/empresas',
    update: '/administracion/empresas',
    delete: '/administracion/empresas',
  },
  relationRolService: {
    list: '/administracion/serviciosRol/consultarRegistrosProInd',
    create: '/administracion/serviciosRol/dinamicAccordion',
  },
  client: {
    list: `/clientes`,
    getPayments: (empresa, sucursal, fecha) => `/clientes/infoTabla/${empresa}/${sucursal}/${fecha}`,
    create: '/clientes',
    uploadFile: '/clientes/upload'
  },
  databaseClients: {
    list: `/administracion/clientes`,
  },
  history: {
    list: `/historico`,
    getCardPayments: (empresa, sucursal, fecha, fechaFinal, estado) => `/historico/ordenesTarjetas/${empresa}/${sucursal}/${fecha}/${fechaFinal}/${estado}`,
    getCashPayments: (empresa, sucursal, fecha, fechaFinal, estado) => `/historico/pagosEfectivo/${empresa}/${sucursal}/${fecha}/${fechaFinal}/${estado}`,
  },
  dashboard: {
    getKpis: `/dashboards/kpis`,
    getProductosVendidos: `/dashboards/productosVendidos`,
    getTendenciaTickets: `/dashboards/tendenciaTickets`,
    getTopClientes: `/dashboards/topClientes`,
  },
  comparisons: {
    getKpis: `/dashboards/comparisons/kpis`,
    getSales: `/dashboards/comparisons/sales`,
    getClients: `/dashboards/comparisons/clients`,
    getCalendar: `/dashboards/comparisons/calendar`,
  },
  datosGenerales: {
    getDatosGenerales: `/datosGenerales`,
    getDatosGeneralesDeptos: `/datosGenerales/departamentos`,
    getDatosGeneralesMunis: `/datosGenerales/municipios`,
    getDatosGeneralesEmpresas: `/datosGenerales/empresas`,
    getDatosGeneralesBancos: `/datosGenerales/bancos`,
  },
  kitchen: {
    list: '/ventas/comandas/cocina',
    updateCommand: '/ventas/comandas/finalizar',
    updateProduct: '/ventas/comandas/parcial',
  },
  cashbox: {
    historial: '/cajas/control/historial',
    resumen: '/cajas/control/resumen',
    control: '/cajas/control',
  },
  cashiers: {
    list: '/administracion/cajeros',
    create: '/administracion/cajeros',
    update: '/administracion/cajeros',
    delete: '/administracion/cajeros',
  },
  categories: {
    list: '/administracion/categorias',
    create: '/administracion/categorias',
    update: '/administracion/categorias',
    delete: '/administracion/categorias',
  },
  inventario: {
    getPronostico: '/dashboards/inventario/pronostico',
  },
  reportes: {
    getReporteVentas: '/reportes/ventas',
  },
  autoservice: {
    menu: '/administracion/productos',
    createOrder: '/ventas/transaccionV2',
    anularVenta: '/ventas/transaccionV2/anular',
    emitirFactura: '/ventas/transaccionV2/emitirFactura',
    validarIdentificacion: '/ventas/transaccionV2/validarIdentificacionAutoservicio',
    validarIdentificacionv1: '/ventas/transaccion/validarIdentificacion',
    createOrderV1: '/ventas/transaccion',
    anularVentaV1: '/ventas/transaccion/anular',
    otpSolicitar: '/ventas/tarjetasGuardadas/otp/solicitar',
    otpVerificar: '/ventas/tarjetasGuardadas/otp/verificar',
    tarjetasGuardadas: '/ventas/tarjetasGuardadas',
  },
  autogestion: {
    mesas: {
      list: '/administracion/mesas-autoservicio',
      create: '/administracion/mesas-autoservicio',
      update: '/administracion/mesas-autoservicio',
      delete: '/administracion/mesas-autoservicio',
      consultar: '/administracion/mesas-autoservicio/consultar',
    }
  },
  combo: {
    list: '/administracion/combos',
    create: '/administracion/combos',
    update: '/administracion/combos',
    delete: '/administracion/combos',
    detail: '/administracion/combos/detalle',
  },
  attribute: {
    list: '/administracion/atributos',
    create: '/administracion/atributos',
    update: '/administracion/atributos',
    delete: '/administracion/atributos',
  },
  extras: {
    list: '/administracion/extras',
    disponibles: '/administracion/extras/disponibles',
  },
  printers: {
    list: '/administracion/impresoras',
    create: '/administracion/impresoras',
    update: '/administracion/impresoras',
    delete: '/administracion/impresoras',
    categories: {
      list: '/administracion/impresoras-categorias',
      disponibles: '/administracion/impresoras-categorias/disponibles',
      update: '/administracion/impresoras-categorias',
    }
  },
  care: {
    appointmentType: {
      list: '/care/appointmentType',
      create: '/care/appointmentType',
      update: '/care/appointmentType',
      delete: '/care/appointmentType',
      users: '/administracion/usuarios'
    },
    appointment: {
      list: '/care/appointment',
      create: '/care/appointment',
      update: '/care/appointment',
      cancel: '/care/appointment/cancel/record'
    },
    record: {
      list: '/care/record',
      create: '/care/record',
      update: '/care/record',
      delete: '/care/record',
      createPatientInjection: '/care/record/patient/injection',
      deletePatientInjection: '/care/record/patient/injection',
      cratePatient: '/care/record/patient',
      expedientPatient: '/care/record/patient/expedient',
      deletePatient: '/care/record/patient',
    },
    cancelationReason: {
      list: '/care/cancelationReason',
      create: '/care/cancelationReason',
      update: '/care/cancelationReason',
      cancel: '/care/cancelationReason'
    }
  },
  ordenes: {
    create: '/ordenes/porCobrar',
    getEstado: '/ordenes/consultarEstado'
  },
  traslados: {
    list: '/administracion/traslados',
    create: '/administracion/traslados',
    update: '/administracion/traslados',
    delete: '/administracion/traslados',
  },
  proveedores: {
    list: '/administracion/proveedores',
    buscar: '/administracion/proveedores/buscar',
    create: '/administracion/proveedores',
    update: '/administracion/proveedores',
    delete: '/administracion/proveedores',
  },
  compras: {
    list: '/administracion/compras',
    detail: '/administracion/compras/detalle',
    create: '/administracion/compras',
    anular: '/administracion/compras/anular',
    proximosVencer: '/administracion/compras/proximos-vencer',
  },
  AI: {
      chatAi: '/chatAi',
      getChatAi: '/chatAi'
    },
  onboarding: {
      verify: (uuid) => `/onboarding/verify/${uuid}`,
      status: (uuid) => `/onboarding/${uuid}/status`,
      documentosRequeridos: (uuid) => `/onboarding/${uuid}/documentos-requeridos`,
      empresa: (uuid) => `/onboarding/${uuid}/empresa`,
      usuarios: (uuid) => `/onboarding/${uuid}/usuarios`,
      documentos: (uuid) => `/onboarding/${uuid}/documentos`,
      documentoDetalle: (uuid, idDocumento) => `/onboarding/${uuid}/documentos/${idDocumento}`,
      documentoDescargar: (uuid, idDocumento) => `/onboarding/${uuid}/documentos/${idDocumento}/descargar`,
      documentoTexto: (uuid) => `/onboarding/${uuid}/documentos-texto`,
      completarEtapa1: (uuid) => `/onboarding/${uuid}/etapa1/completar`,
      validarIdentificacion: (uuid) => `/onboarding/${uuid}/validar-identificacion`,
  
      // Etapa 2 - Customización
      catalogoCuotas: (uuid) => `/onboarding/${uuid}/config/catalogo-cuotas`,
      catalogoMetodosPago: (uuid) => `/onboarding/${uuid}/config/catalogo-metodos-pago`,
      sucursalesEstado: (uuid) => `/onboarding/${uuid}/config/sucursales-estado`,
      configLogo: (uuid) => `/onboarding/${uuid}/config/logo`,
      configCajeros: (uuid) => `/onboarding/${uuid}/config/cajeros`,
      configMetodosPago: (uuid) => `/onboarding/${uuid}/config/metodos-pago`,
      configMetodoPagoDetalle: (uuid, idMetodo) => `/onboarding/${uuid}/config/metodos-pago/${idMetodo}`,
      configPoliticas: (uuid) => `/onboarding/${uuid}/config/politicas`,
      copiarSucursal: (uuid) => `/onboarding/${uuid}/config/copiar-sucursal`,
      completarEtapa2: (uuid) => `/onboarding/${uuid}/etapa2/completar`,
  
      // Etapa 3 - Activaciones
      activaciones: (uuid) => `/onboarding/${uuid}/activaciones`,
      activacionFelCarta: (uuid) => `/onboarding/${uuid}/activaciones/fel/carta`,
      activacionFelCartaDescargar: (uuid) => `/onboarding/${uuid}/activaciones/fel/carta/descargar`,
      activacionFelPlantillaDescargar: (uuid) => `/onboarding/${uuid}/activaciones/fel/carta-plantilla/descargar`,
  
      // Etapa 5 - Tutoriales completado
      completarEtapa5: (uuid) => `/onboarding/${uuid}/etapa5/completar`,
    }
  };
